<template>
  <div v-if="loading === false">
    <b-container fluid v-if="($mq === 'mobile' || $mq === 'tablet')" style="min-height:50vh;">
      <!-- header -->
      <HeaderBackMobile :backToHome="true"/>
      <main>
        <section v-if="offers.length">
          <b-row class="align-items-center">
            <b-col cols="3" style="padding:20px;">
              <font-awesome-icon style="font-size:60px;opacity:0.8;" :style="{color: getCssColor('primary_bt')}" :icon="['fas', 'badge-percent']"/>
            </b-col>
            <b-col cols="8" style="color: rgb(99, 96, 92);padding:20px;">
              <div  v-if="$store.state.company.offers_information && $store.state.company.offers_information.description">{{$store.state.company.offers_information.description}}</div>
              <div  v-else>Ative ofertas para lojas físicas. Receba o desconto informando o CPF ou código de ativação no caixa.</div>
            </b-col>
          </b-row>
          <b-row align-h="center">
            <b-col cols="10" style="border-bottom: 1px solid #c0c0c0;"></b-col>
          </b-row>
          <template v-for="(offer, idxo) in offers">
          <b-row v-if="offer.active" v-bind:key="idxo" style="margin-bottom:10px;">
            <b-col cols="12"
              style="
                color: #2C2A29;
                font-size: 20px;
                padding: 20px;
                font-weight: 500;"
            >{{offer.name}}
            </b-col>
            <b-col cols="12" style="padding:0 15px;">
              <div class="promoProductsHorizontalMobile">
                <template v-for="(product, idxp) in offer.products_offers">
                  <div v-bind:key="idxp" v-if="(offer.offer_type === 'CPF' || !offer.offer_type) || (product.available_codes > 0 || product.code)" class="promoProduct">
                    <div style="width:180px;height:180px;text-align:center;position:relative;">
                      <img v-if="product.img" :src="productImageURI + '/' + product.img" style="max-width:180px;max-height:180px;"/>
                      <div v-if="product.offer_discount" class="promoLabel" :style="{backgroundColor: getCssColor('primary_bt')}">{{product.offer_discount}}%</div>
                    </div>
                    <div class="productName">
                      <template v-if="product.name">{{product.name.toLowerCase()}}</template>
                    </div>
                    <div class="maxQtdPromo">
                      <template v-if="product.max_quantity_per_sale">máximo por compra: {{product.max_quantity_per_sale}}</template>
                    </div>
                    <div v-if="!product.active" @click="activateOffer(offer.id, product.product_id)" class="activateOffer" :style="{backgroundColor: getCssColor('primary_bt')}">
                      ATIVAR
                    </div>
                    <div v-else-if="product.code" class="activeOffer">
                      {{product.code}}
                    </div>
                    <div v-else class="activeOffer">
                      ATIVO
                    </div>
                </div>
                </template>
              </div>
            </b-col>
          </b-row>
          </template>
          <b-row style="height:60px;">
            <b-col cols="12" style="font-size:16px;text-align:center;">* Ofertas validas enquanto durarem os estoques</b-col>
          </b-row>
        </section>
        <section v-else>
          <b-row  style="margin-top:21px;height:48px;">
            <b-col cols="12" style="text-align:center;">
              <font-awesome-icon style="font-size:40px;color: #525962;margin:15px;"  :icon="['fal', 'sad-cry']"/>
            </b-col>
            <b-col cols="12" style="text-align:center;color: #525962;">
              Não existem ofertas disponíveis no momento.
            </b-col>
          </b-row>
        </section>
      </main>
      <!-- footer-->
    </b-container>
    <b-container fluid v-else style="min-height:100vh;background-color:#F5F6F7;">
      <b-row>
        <StoreHeader/>
      </b-row>
      <main>
        <section v-if="offers.length">
          <b-row align-h="center">
            <b-col cols="1" style="text-align:center;padding:20px;">
              <font-awesome-icon style="font-size:60px;opacity:0.8;" :style="{color: getCssColor('primary_bt')}" :icon="['fas', 'badge-percent']"/>
            </b-col>
            <b-col cols="4" style="color: rgb(99, 96, 92);height:100px;">
              <div style="margin-top:25px;" v-if="$store.state.company.offers_information && $store.state.company.offers_information.description">{{$store.state.company.offers_information.description}}</div>
              <div style="margin-top:25px;" v-else>Ative as ofertas para lojas físicas. Receba o desconto informando o CPF ou código de ativação no caixa.</div>
            </b-col>
          </b-row>
          <b-row align-h="center">
            <b-col cols="5" style="border-bottom: 1px solid #c0c0c0;"></b-col>
          </b-row>
          <template v-for="(offer, idxo) in offers">
            <b-row v-if="offer.active" v-bind:key="idxo" align-h="center" style="padding-bottom:10px;">
              <b-col cols="12"
                     style="
                color: #2C2A29;
                font-size: 24px;
                padding: 20px;
                font-weight: 500;
                text-align:center;"
              >{{offer.name}}
              </b-col>
              <b-col cols="12" style="padding:0 15px;">
                <b-row align-h="center" class="promoProductDesk">
                  <template v-for="(product, idxp) in offer.products_offers">
                    <b-col cols="3" v-bind:key="idxp" v-if="(offer.offer_type === 'CPF' || !offer.offer_type) || (product.available_codes > 0 || product.code)" class="promoProduct">
                      <div style="text-align:center;position:relative;margin:0px auto;height:200px;margin-top:10px;">
                        <img v-if="product.img" :src="productImageURI + '/' + product.img" style="max-width:230px;max-height:200px;"/>
                        <div v-if="product.offer_discount" class="promoLabel" :style="{backgroundColor: getCssColor('primary_bt')}">{{product.offer_discount}}%</div>
                      </div>
                      <div class="productName">
                        <template v-if="product.name">{{product.name.toLowerCase()}}</template>
                      </div>
                      <div class="maxQtdPromo">
                        <template v-if="product.max_quantity_per_sale">máximo por compra: {{product.max_quantity_per_sale}}</template>
                      </div>
                      <div v-if="!product.active" @click="activateOffer(offer.id, product.product_id)" class="activateOffer" :style="{backgroundColor: getCssColor('primary_bt')}">
                        ATIVAR
                      </div>
                      <div v-else-if="product.code" class="activeOffer">
                        {{product.code}}
                      </div>
                      <div v-else class="activeOffer">
                        ATIVO
                      </div>
                    </b-col>
                  </template>
                </b-row>
              </b-col>
            </b-row>
          </template>
          <b-row style="height:60px;">
            <b-col cols="12" style="font-size:22px;text-align:center;">* Ofertas validas enquanto durarem os estoques</b-col>
          </b-row>
        </section>
        <section v-else>
          <b-row  style="margin-top:21px;height:48px;">
            <b-col cols="12" style="text-align:center;">
              <font-awesome-icon style="font-size:40px;color: #525962;margin:15px;"  :icon="['fal', 'sad-cry']"/>
            </b-col>
            <b-col cols="12" style="text-align:center;color: #525962;">
              Não existem ofertas disponíveis no momento.
            </b-col>
          </b-row>
        </section>
      </main>
    </b-container>
    <Footer />
  </div>
  <div v-else>
    <InnerLoading/>
  </div>
</template>

<script>
import UserConn from '@/connection/user'
import OffersConn from '@/connection/offers'
import InnerLoading from '@/components/InnerLoading'
import HeaderBackMobile from '@/components/HeaderBackMobile.vue'
import StoreHeader from '@/components/StoreHeader.vue'
import Footer from '@/components/Footer.vue'
import colors from '@/mixins/colors'
import { EventBus } from '@/behaviours/event-bus'

export default {
  data () {
    return {
      offers: [],
      loading: true,
    }
  },

  mixins: [colors],

  components: {InnerLoading, HeaderBackMobile, StoreHeader, Footer},

  async mounted() {

    if (UserConn.isLoggedIn()) {
      let result = await OffersConn.getAllOffers()
      console.log('mount offers')
      console.log(result)
      if (!result.error) {
        await this.checkActiveOffers(result)
        this.clearEmptyOfferList(result)
        this.offers = result
      } else {
        EventBus.$emit('showAlert', 'error', 'Erro ao obter lista de ofertas')
      }
    } else {
      this.$store.state.registerLoginOrigin = 'offers'
      this.$router.push({path: '/login'})
    }
    this.loading = false
  },

  computed: {
    productImageURI () {
      return this.$store.getters.getProductImageURI
    }
  },

  methods: {
    async activateOffer (offerId, productId) {
      this.$store.state.showLoading = true
      let result = await OffersConn.activateOffer(offerId, productId)
      this.$store.state.showLoading = false

      if (result.error) {
        EventBus.$emit('showAlert', 'error', result.msg)
      } else {
        let lastActivatedOffer = this.offers.find(offer => offer.id === offerId)
        if (lastActivatedOffer && lastActivatedOffer.offer_type === 'CODE') {
          let mapCode =  result.code_list.find(product => product.product_id === productId)
          let code = mapCode.code
          lastActivatedOffer.products_offers.find(product => product.product_id === productId).code = code
        }
        this.$forceUpdate()
      }
    },

    async checkActiveOffers(result) {
      for (const offer of result) {
        let allUserOffers = await OffersConn.getAllUserOffers(offer.id)
        if (allUserOffers && !allUserOffers.error && allUserOffers.products_ids && allUserOffers.products_ids.length) {
          allUserOffers.products_ids.forEach((activeId) => {
            offer.products_offers.filter(productOffer => productOffer.product_id === activeId).forEach((productOfferActivated) => {
              productOfferActivated.active = true;
              allUserOffers.code_list.filter(cl => cl.product_id === activeId).forEach((OfferCodeList) => {
                productOfferActivated.code = OfferCodeList.code;
              })
              this.$forceUpdate()
            })
          })
        }
      }
    },

    clearEmptyOfferList(offerList) {
      offerList.forEach(offer => {
        if (offer.offer_type ==='CODE') {
          offer.products_offers.forEach(product => {
            if (product.available_codes > 0 || product.code) {
              offer.active = true
            }
          })
        } else {
          offer.active = true
        }
      })
    }
  }
}
</script>

<style lang="scss">
.promoProductsHorizontalMobile {
  width:100%;
  height:330px;
  overflow-x:auto;
  -webkit-overflow-scrolling: touch;
  overflow-y:hidden;
  padding-right:5px;
  display: flex;

  .promoProduct {
    border-radius:4px;
    min-width: 200px;
    width: 200px;
    height: 320px;
    margin: 0 5px;
    padding: 10px;
    border: 1px solid #DAD7D4;
  }

  .promoLabel {
    border-radius:4px;
    height:24px;
    width:74px;
    position:absolute;
    top:0px;
    left:0px;
    z-index:2;
    line-height:24px;
    font-size: 14px;	font-weight: 500; color:#ffffff;
  }

  .productName {
    color: #312922;
    font-size: 14px;
    font-weight: 500;
    padding: 0 5px;
    height:45px;
    width:180px;
    overflow: hidden;
    overflow-wrap: break-word;
    text-overflow: ellipsis;
    margin-top:5px;
    text-align:center;
    text-transform: capitalize;
    }

  .maxQtdPromo {
    color: #312922;
    font-size: 12px;
    font-weight: 500;
    padding: 0 5px;
    height:20px;
    width:180px;
    overflow: hidden;
    overflow-wrap: break-word;
    text-overflow: ellipsis;
    margin-top:5px;
    text-align:center;
  }

  .activateOffer {
    margin:5px auto;
    width:calc( 100% - 30px);height:32px;
    line-height:32px;
    border-radius:4px;
    text-align:center;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    text-transform: uppercase;
    color: #FFFFFF;
  }

  .activeOffer {
    background-color: #c0c0c0;
    margin:5px auto;
    width:calc( 100% - 30px);height:32px;
    line-height:32px;
    border-radius:4px;
    text-align:center;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    text-transform: uppercase;
    color: #FFFFFF;
  }
}


/** DESK **/
.promoProductDesk {
  min-height:400px;

  .promoProduct {
    min-width: 250px;
    height: 380px;
    margin: 15px 5px;;
    background-color: #ffffff;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    padding-top:10px;
  }

  .promoLabel {
    border-radius:4px;
    height:24px;
    width:74px;
    position:absolute;
    top:-10px;
    left:0px;
    z-index:2;
    line-height:24px;
    font-size: 14px;	font-weight: 500; color:#ffffff;
  }

  .productName {
    color: #312922;
    font-size: 16px;
    font-weight: 500;
    padding: 0 5px;
    height:50px;
    overflow: hidden;
    overflow-wrap: break-word;
    text-overflow: ellipsis;
    margin-top:10px;
    text-align:center;
    text-transform: capitalize;
    }

  .maxQtdPromo {
    color: #312922;
    font-size: 14px;
    font-weight: 500;
    padding: 0 5px;
    height:20px;
    overflow: hidden;
    overflow-wrap: break-word;
    text-overflow: ellipsis;
    margin-top:10px;
    margin-bottom:20px;
    text-align:center;
  }

  .activateOffer {
    margin:5px auto;
    width:calc( 100% - 30px);height:32px;
    line-height:32px;
    border-radius:4px;
    text-align:center;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    text-transform: uppercase;
    color: #FFFFFF;
  }

  .activeOffer {
    background-color: #c0c0c0;
    margin:5px auto;
    width:calc( 100% - 30px);height:32px;
    line-height:32px;
    border-radius:4px;
    text-align:center;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    text-transform: uppercase;
    color: #FFFFFF;
  }
}
</style>
